import { PasswordForgot, PasswordRegister, PasswordReset } from '@anytag/app';
import { PartialRouter } from '../../types';

export const PasswordRouter = {
  '/_public-routes/_password/password_forgot': [PasswordForgot, {}],
  '/_public-routes/_password/password_register/$token': [PasswordRegister, {}],
  '/_public-routes/_password/password_reset/$token': [PasswordReset, {}]
} as const satisfies PartialRouter;
